import { FC } from 'react';

export const Description: FC = ({ children }) => {
    return (
        <div className='bg-white rounded-[16px] lg:rounded-30px px-5 lg:px-16 py-10 my-12'>
            {children}
        </div>
    );
};
